/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Civil_Lucky_Bumblebee_TwistInputs */

const fr_civil_lucky_bumblebee_twist = /** @type {(inputs: Civil_Lucky_Bumblebee_TwistInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Slug`)
};

/**

* @param {Civil_Lucky_Bumblebee_TwistInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const civil_lucky_bumblebee_twist = /** @type {((inputs?: Civil_Lucky_Bumblebee_TwistInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Civil_Lucky_Bumblebee_TwistInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_civil_lucky_bumblebee_twist(inputs)
});